<template lang="pug">
  div
    el-card(shadow="hover").card-container
      app-divider(label="Dados do VTN: ", :addMarginTop="false").margin-bottom

      div.campos-grid
        div
          app-label.appLabel(:label="`Área requerida (${tipoArea}):`", :required="true")
          validation-provider(:rules="isReurbIndividual ? 'required|notZero' : ''", v-slot="{ errors }")
            app-double-input.appInput(
              :hasValidationError="errors.length > 0",
              name='Área',
              :precision="isReurbIndividual ? 2 : 4",
              :onkeypress="onlyInputNumbers",
              v-model="vtnRequest.areaRequerida",
            )
            span.help.erro {{ errors[0] }}

        div
          app-label.appLabel(label="Munícipio:", :required="true")
          el-input(
            v-model="vtnRequest.municipio.nome",
            :disabled="true"
          )

        div(v-if="!isReurbIndividual")
          validation-provider(rules="required", v-slot="{ errors }")
            app-label.appLabel(label="Nível:", :required="true")
            el-select(
              :class="{'erro' : errors.length}",
              v-model="vtnRequest.nivel"
            )
              el-option(
                v-for="nivel in niveis"
                :key="nivel.codigo"
                :label="nivel.nome"
                :value="nivel.codigo"
              )
            span.help.erro {{ errors[0] }}

        div
          app-label.appLabel(:label="`Valor de referência/${tipoArea}:`", :required="true")
          validation-provider(
            v-slot="{ errors }"
          )
            div(class="el-input-group el-input-group--prepend appInput")
              app-double-input(
                v-model="valorReferencia",
                name='Valor de referência',
                :hasValidationError="errors.length > 0",
                :precision="2",
                :onkeypress="onlyInputNumbers",
                :disable="!isReurbIndividual"
              )
            span.help.erro {{ errors[0] }}

        div
          app-label.appLabel(
              :label="isReurbIndividual ? 'Valor total a ser pago:' : 'Valor de referência do imóvel:'",
              :required="true"
            )
          div(class="el-input-group el-input-group--prepend appInput")
            app-double-input(
              v-model="valorReferenciaImovel",
              name='valorReferenciaImovel',
              :precision="2",
              :onkeypress="onlyInputNumbers",
              :disable="true"
            )

        div
          app-label.appLabel(
              :label="isReurbIndividual ? 'Valor total:' : 'VTN:'",
              :required="true"
            )
          div(class="el-input-group el-input-group--prepend appInput")
            app-double-input(
              v-model="valorVtn",
              name='valorVtn',
              :precision="2",
              :onkeypress="onlyInputNumbers",
              :disable="true"
            )

      div.center
        el-col(:span='8')
          el-checkbox(
              v-model="vtnRequest.taxaDiversa",
              :style="{ margin: '20px 0 20px 0' }"
            ) Taxas diversas (10% do valor do VTN)
  </template>
<script>

import onlyInputNumbers from '@/components/mixins/OnlyInputNumber'
import AppLabel from '@/components/AppLabel'
import AppDoubleInput from '@/components/AppDoubleInput'
import AppDivider from '@/components/AppDivider.vue'
import AppDisplay from '@/components/AppDisplay'
export default {
  mixins: [onlyInputNumbers],
  components: {
    AppDivider,
    AppDisplay,
    AppLabel,
    AppDoubleInput
  },

  props: {
    vtnRequest: {
      type: Object,
      required: true
    },
    tipoProcesso: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      input: '',
      disable: true,
      temMunicipio: false,
      municipios: [],
      niveis: [

        { codigo: 'N1', nome: 'Nível 1' },
        { codigo: 'N2', nome: 'Nível 2' },
        { codigo: 'N3', nome: 'Nível 3' },
        { codigo: 'N4', nome: 'Nível 4' },
        { codigo: 'N5', nome: 'Nível 5' }

      ]
    }
  },

  mounted () {
    if (!this.vtnRequest.nivel) {
      this.vtnRequest.nivel = 'N1'
    }
    if (this.isReurbIndividual) {
      this.$set(this.vtnRequest, 'valorReferencia', this.vtnRequest.valorReferencia || 0)
      this.$set(this.vtnRequest, 'valorVtn', this.vtnRequest.valorVtn || 0)
      this.$set(this.vtnRequest, 'valorReferenciaImovel', this.vtnRequest.valorReferenciaImovel || 0)
    }
  },

  watch: {
    valorReferencia (val) {
      if (this.isReurbIndividual) {
        this.$set(this.vtnRequest, 'valorReferencia', val)
      }
    },
    valorVtn (val) {
      this.$set(this.vtnRequest, 'valorVtn', val)
    },
    valorReferenciaImovel (val) {
      this.$set(this.vtnRequest, 'valorReferenciaImovel', val)
    }
  },

  computed: {
    isAmapa () {
      return process.env.ESTADO === 'ap'
    },
    valorReferencia: {
      get () {
        if (!this.vtnRequest) return 0
        if (this.isReurbIndividual) {
          return this.vtnRequest.valorReferencia || 0
        }
        if (!this.vtnRequest.nivel || !this.vtnRequest.areaRequerida) return 0
        return this.vtnRequest.municipio.valorNivelMunicipio[this.vtnRequest.nivel.toLowerCase()]
      },
      set (valor) {
        if (this.isReurbIndividual) {
          this.$set(this.vtnRequest, 'valorReferencia', valor)
        }
      }
    },
    valorReferenciaImovel () {
      const vtn = this.valorVtn
      if (!this.vtnRequest) return 0
      if (!this.isReurbIndividual && (!this.vtnRequest.nivel || !this.vtnRequest.areaRequerida)) return 0
      return this.vtnRequest.taxaDiversa ? vtn * 1.1 : vtn
    },
    valorVtn: {
      get () {
        if (!this.vtnRequest || !this.vtnRequest.areaRequerida) return 0
        if (!this.isReurbIndividual && !this.vtnRequest.nivel) return 0
        return this.valorReferencia * this.vtnRequest.areaRequerida
      },
      set () { }
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.tipoProcesso)
    },
    tipoArea () {
      return this.isReurbIndividual ? 'm²' : 'ha'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.card-container {
  margin: 20px;
  border-radius: 10px;
}

.margin-bottom {
  margin-bottom: 20px;
}

.campos-grid {
  display: grid;
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  grid-auto-columns: 1fr;
  gap: 20px 7%;
}

.appLabel {
  flex: 1;
}

.appInput {
  flex: 0.5;

  >>>.el-input__inner {
    border-radius: 4px !important;
  }
}

.el-input__inner {
  border-radius: 4px;
  font-size: 14px;
}

.el-input-group__append {
  color: $--color-text-regular
}

.erro {
  border-color: $--color-danger !important;
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/vtn/components/InformarDadosMa.vue